<template>

  <article class="funding">
    <div class="box-hero -degradate">
      <div class="box-text container">
        <div class="row row-responsive">
          <div class="column column-xs-100 -centered-info">
            <h1 class="maintitle -medium"><b>Factoraje</b> para tu empresa</h1>
          </div>
          <div class="column -centered-info">
            <a
              href="https://financiamiento.cumplo.mx/"
              class="button button-action button-large">
              ¡Aplica ahora!
            </a>
          </div>
        </div>
      </div>
      <div class="box-numbers container -centered-info">
        <div class="row row-responsive">
          <div class="column column-sm-50">
            <img
              src="https://secure-cdn.cumplo.cl/assets/cumplo2017/icon-money-arrow-7beda12185d6cd87e26d20f1febc59fa.svg"
              class="icon"
            >
            <span class="number">
              +
              <animated-number
              :value="financedCredits"
              :duration="1200"
              :round="1"
              />
            </span>
            <span class="text">créditos financiados</span>
          </div>
          <div class="column column-sm-50">
            <img
              src="https://secure-cdn.cumplo.cl/assets/cumplo2017/icon-coins-2-49b77faebcd829cc6af36f811191bccf.svg"
              class="icon"
            >
            <span class="number">
              +
              <animated-number
              :value="millionInvested"
              :formatValue="formatUSCurrency"
              :duration="1000"
              />
            </span>
            <span class="text">millones de pesos invertidos</span>
          </div>
        </div>
      </div>
    </div>
    <FundingCarousel></FundingCarousel>
    <FundingSteps></FundingSteps>
    <InvestmentCreditTypes></InvestmentCreditTypes>
    <FundingFaq></FundingFaq>
    <BottomInfo></BottomInfo>
  </article>

</template>

<script>

import FundingCarousel from './funding/FundingCarousel'
import FundingFaq from './funding/FundingFaq'
import FundingSteps from './funding/FundingSteps'
import InvestmentCreditTypes from '@/components/CreditTypes'
import BoxHero from '@/partials/BoxHero'
import BottomInfo from '@/partials/BottomInfo'

import mixins from '@/mixins/index'

import AnimatedNumber from 'animated-number-vue'

export default {
  name: 'Funding',
  metaInfo () {
    return {
      title: 'Financiamiento'
    }
  },
  components: {
    BoxHero,
    BottomInfo,
    FundingCarousel,
    FundingFaq,
    FundingSteps,
    InvestmentCreditTypes,
    AnimatedNumber
  },
  mixins: [mixins],
  data () {
    return {
      millionInvested: process.env.MILLION_INVESTED,
      financedCredits: process.env.FINANCED_CREDITS
    }
  }
}

</script>

<style lang="scss" scoped>

.funding {

  .box-hero {
    position: relative;
    padding: 8rem 0 5rem;
    background: url('/static/images/bg-funding.jpg') center center no-repeat;
    background-size: cover;
    color: $white;

    @media (min-width: 42rem) {
      padding: 6rem 0 3rem;
    }

    .secondarytitle {
      font-size: 1.5em;
    }

    .box-numbers {
      margin-top: 3rem;

      .icon {
        display: none;

        @media (min-width: 42rem) {
          display: inline-block;
          height: 30%;
        }
      }

      .number,
      .text {
        display: block;
        text-align: center;
        line-height: 1.1;
      }

      .number {
        font-size: 3em;
        font-weight: 300;
        letter-spacing: 0;
        margin-bottom: 6px;
      }

      .text {
        text-transform: uppercase;
        color: $white;
        letter-spacing: 2px;
        font-size: .8em;
        margin-bottom: 2rem;

        @media (min-width: 42rem) {
          margin-bottom: 0;
        }
      }
    }
  }

  .maintitle {
    margin-bottom: 3rem;
    font-size: 2.6em;
  }

  .box-registration-cta {
    padding: 3rem;
    border: 1px solid #ccc;
    border-radius: 2rem;
    margin: 2rem;
    background: #efefef;

    .maintitle {
      font-size: 1.8em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Funding.vue